import { render, staticRenderFns } from "./ConfirmResetPasswordToken.vue?vue&type=template&id=efd3fcb6&"
import script from "./ConfirmResetPasswordToken.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPasswordToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports